import React from 'react'

const PaymentCampaignInfluencerSkeleton = () => {
    return (
        <div className="grid grid-cols-12 gap-4 py-6 border-b border-lightGray last:border-0">
            <div className='flex flex-col gap-y-6 md:col-span-6 col-span-12'>
                <div className='flex items-center gap-2.5'>
                    <div className='min-w-12 w-12 h-12 rounded-full overflow-hidden bg-gray animate-pulse'></div>
                    <div className='flex flex-col gap-1'>
                        <h5 className='font-semibold text-lg leading-6 animate-pulse bg-gray rounded w-40 h-6'></h5>
                        <div className='flex items-center gap-2'>
                            <span className='text-sm leading-6 animate-pulse bg-gray rounded w-8 h-6'></span>
                            <div className='w-1 h-1 bg-gray rounded-full'></div>
                            <span className='text-sm leading-6 animate-pulse bg-gray rounded w-8 h-6'></span>
                        </div>
                    </div>
                </div>
                <span className='text-sm leading-6 animate-pulse bg-gray rounded w-40 h-7'></span>
            </div>
            <div className='flex flex-col gap-y-3 items-start md:col-span-3 col-span-6'>
                <span className={`rounded-md px-2.5 text-white font-medium text-sm capitalize py-0.5  bg-gray w-20 h-6 animate-pulse`}></span>
                <span className='font-semibold bg-gray rounded w-20 h-6 animate-pulse'></span>
                <span className='font-semibold bg-gray rounded w-20 h-6 animate-pulse'></span>
            </div>
            <div className='md:col-span-3 col-span-6 self-center text-end justify-self-end'>
                <div className='bg-gray rounded  font-medium w-40 h-10 animate-pulse'></div>
            </div>
        </div>
    )
}

export default PaymentCampaignInfluencerSkeleton
